var exports = {
  "kL": "xe564cbfb--c30542--container",
  "MK": "xe564cbfb--c30542--suggest_list",
  "jt": "xe564cbfb--c30542--suggest_list_handler",
  "s4": "xe564cbfb--c30542--suggest_list_input_handler",
  "HW": "xe564cbfb--c30542--suggest_list_close_icon",
};

module.exports = exports;
